var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mentions-menu"},_vm._l((_vm.mentionOptions),function(user,index){return _c('div',{key:user.id,staticClass:"user-option",class:{
      'selected': _vm.selected === index,
    },on:{"click":function($event){return _vm.mentionByIndex(index)}}},[_c('MiniEntity',{staticClass:"mini-entity",attrs:{"entity":user,"white-text":_vm.selected === index}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }